<div *ngIf="cmsLanding$ | async as cmsLanding; else categoryContent">
    <cms-render-lazy [slug]="cmsLanding.shortDescription"></cms-render-lazy>
</div>

<ng-template #categoryContent>
    <div class="category-layout w-100 mb-16 content-apollo is-category-tool-open" *ngIf="!hasMicrositeLegacy">
        <div categoryPageStyles class="content-apollo-height">
            <div>
                <category-tool-bar
                    [category]="getMenuCategory$ | async"
                    [isFilterApplied]="isFilterApplied"
                    [selectGridView]="selectGridView"
                    [filters]="filters$$()"
                    [filterTypeUsed]="filterTypeUsed$$()"
                    [currentCategory]="currentCategory$$()"
                    (updateFilterEmitter)="updateFilter($event)"
                    (categoryIdEmitter)="updateCategoryId($event)"
                    (showFilterEmitter)="updateShowFilter($event)"
                    (categoryNameInfoEmitter)="updateCategoryNameInfo($event)"
                >
                    <category-filter-badge categoryFilterBadge *ngIf="isFilterApplied && showFilter"></category-filter-badge>
                </category-tool-bar>

                <category-grid> </category-grid>
            </div>
        </div>

        <div class="container-fluid pr-body pl-body">
            <div class="row">
                <div class="col-sm-2"></div>
                <div class="col-xs-12 col-sm-8">
                    <category-seo></category-seo>
                </div>
            </div>
        </div>
    </div>

    @if (gridDefaultFullyLoaded$ | async) {
        <div>
            @defer (when (hideRelateds$ | async) === false; prefetch on idle) {
                @if (relatedProductsVm$ | async; as relatedProductsVm) {
                    <related-products [place]="relatedProductsVm.place" [categoryId]="relatedProductsVm.categoryId"></related-products>
                }
            }
        </div>
    }

    <div class="pl-body pr-body mt-64 mb-32" *ngIf="getCategory$ | async as category">
        <breadcrumbs [categoryId]="category?.id"></breadcrumbs>
    </div>

    <ng-template #selectGridView>
        <display-filter
            [gridType]="gridViewValue$ | async"
            [totalFiltersCount]="totalFiltersCount$ | async"
            [category]="getCategory$ | async"
            (gridTypeEmitter)="setGridTypeCategoryGrid($event)"
            (openFilterPanelEmitter)="openFilterPanel()"
        ></display-filter>
    </ng-template>
</ng-template>
